module.exports = __webpack_public_path__ + "media/images/features/4/dress-2-228edbcb35704559e47f0601efefc035.jpg";